import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
const CONTACT_US = 'https://www.torranceca.gov/Government/Contact-Us/Contact-Us';
const YOUTUBE = 'https://www.youtube.com/@TorranceCitiCABLE';
const FACEBOOK = 'https://www.facebook.com/TorranceCA';
const TWITTER = 'https://x.com/TorranceCA';
const INSTAGRAM = 'https://www.instagram.com/cityoftorranceca/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav" aria-label="Footer">
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={YOUTUBE} aria-label="YouTube">
            <FontAwesomeIcon icon={faYoutube}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={FACEBOOK} aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={TWITTER} aria-label="X">
            <FontAwesomeIcon icon={faTwitter}/>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={INSTAGRAM} aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram}/>
          </a>
        </nav>
      </div>
    </footer>);
}
export default Footer;
